import { render, staticRenderFns } from "./VrabotenLayout.vue?vue&type=template&id=c4c4fa32&scoped=true"
import script from "./VrabotenLayout.vue?vue&type=script&lang=js"
export * from "./VrabotenLayout.vue?vue&type=script&lang=js"
import style0 from "./VrabotenLayout.vue?vue&type=style&index=0&id=c4c4fa32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c4fa32",
  null
  
)

export default component.exports